import {
  INIT_ROOT,
  TOGGLE_OPTION_SUCCESS,
  TOGGLE_OPTION_CONFLICT_RESOLVE,
  UPDATE_CONFIG_SUCCESS,
  CLEAR_OPTION_TOGGLED,
} from '../actionTypes';

export default function optionToggled(state, action) {
  switch (action.type) {
    case INIT_ROOT:
      return null;
    case TOGGLE_OPTION_SUCCESS:
    case TOGGLE_OPTION_CONFLICT_RESOLVE:
      return action.payload.option;
    case UPDATE_CONFIG_SUCCESS:
    case CLEAR_OPTION_TOGGLED:
      return null;
    default:
      return state || null;
  }
}
